// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/Gabarito-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/Gabarito-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/fonts/crimson/CrimsonText-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/fonts/crimson/CrimsonText-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/fonts/crimson/CrimsonText-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/fonts/crimson/CrimsonText-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/fonts/crimson/CrimsonText-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/fonts/crimson/CrimsonText-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../public/fonts/crimson/CrimsonText-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../public/fonts/crimson/CrimsonText-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../public/assets/parchment.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Gabarito';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-weight: 400;
}

@font-face {
    font-family: 'Crimson';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: 700;
}

@font-face {
    font-family: 'Crimson';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
    font-weight: 700;
    font-style: italic;
}

@font-face {
    font-family: 'Crimson';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Crimson';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
    font-weight: 400;
}

/* body {
    font-family: "Gabarito", serif;
    font-family: 'Crimson', serif;
} */

::selection {
  background: #df2d11 !important;
}

.App {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #faf8f5;
}

.story-page {
    display: flex;
    height: calc(100vh - 65px);
    overflow: hidden;
}

.sidebar {
    width: 300px;
    height: 100%;
    overflow-y: auto;    
    padding: 40px 24px;
    box-sizing: border-box;
}

.sidebar-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.main-content {
    overflow: hidden;
    width: 100%;
    padding: 40px 64px;
    gap: 20px;
    flex: 1 1;
    height: calc(100vh - 65px);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background: #ded8d1;
    margin-right: 40px;
    border-radius: 12px;
    height: calc(100% - 30px);
}

.book-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 10px;
}

@media (max-height: 800px)  {
    .main-content {
        height: auto;
    }
}

/* Responsive design */
@media (max-width: 1200px) {
    .sidebar {
        display: none;
    }

    .sidebar.show {
        display: block;
        position: fixed;
        z-index: 998;
        background: #fcfaf7;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .main-content {
        padding: 40px 24px;
        margin: 0 16px;
        width: auto;
    }

    .paper-wrapper {
        width: auto;
    }

    .story-page {
        flex-direction: column;
    }


    .toggle-sidebar.btn.theme-button {
        display: flex;
        gap: 10px;
        font-family: "Gabarito", serif;
        border: 1px solid rgba(135, 134, 127, 0.25);
        border-radius: 50px;
        background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));
        background-clip: padding-box;
        margin: 20px 16px;
        box-sizing: border-box;
    }

    .toggle-sidebar.btn.theme-button:hover {
        border: 1px solid rgba(135, 134, 127, 0.5);
    }

    .toggle-sidebar.btn.theme-button:focus {
        border: 1px solid rgba(135, 134, 127, 0.25);
    }

    .toggle-sidebar.btn.theme-button > .icon {
        left: auto;
        position: relative;
    }

    .toggle-sidebar.btn.theme-button > .icon svg {
        width: 20px;
        height: 20px; 
    }

    .toggle-sidebar.btn.theme-button span {
        color: #454545;
        font-size: 16px;
    }

    .hide-sidebar {
        position: relative;
        top: -10px;
        width: 32px;
        height: 32px;
        margin-left: auto;     
        display: flex;
        justify-content: center;   
        align-items: center;
        cursor: pointer;
        border-radius: 4px;
    }

    .hide-sidebar:hover {
        background: rgba(0, 0, 0, 0.05);
    }

    .hide-sidebar svg {
        width: 30px;
        height: 30px;
    }
}

@media (min-width: 1200px) {
    .toggle-sidebar,
    .hide-sidebar {
        display: none !important;
    }
}

.text-panel {
    box-sizing: border-box;
}

.paper-wrapper {
    position: relative;
    width: 100%;
    max-width: calc((100vh - 1rem - 2rem) * 0.69);
    max-height: calc(100vh - 1rem - 2rem);
}

.paper {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 0;
    padding-bottom: 130%;
    border-radius: 2px;
    transform: translateY(-50%);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center/cover, #ffffff;
    filter: grayscale(40%);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* .paper::before {
    content: '';
    background: url("../public/assets/parchment.png") no-repeat center/cover, #ffffff;
    filter: grayscale(40%);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
} */

.paper-wrapper .paper .paper-content {
    padding: 6.593%;
    padding-left: 8.571%;
    padding-right: 5.714%;
}

.paper-wrapper:not(.text-panel) .paper .paper-content {
    padding-right: 8.571%;
    padding-left: 5.714%;
}

.paper-wrapper:not(.text-panel) .paper::before {
    transform: scaleX(-1) rotate(180deg);
}

.paper-wrapper .paper-container {    
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}

.story-container {
    margin: 0 auto;
    font-size: 17px;
    line-height: 1.3;
    white-space: pre-wrap;
    word-wrap: break-word;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.story-container > div h2 {
    font-size: clamp(16px, 2vw, 28px);
    margin: 0;
    text-transform: uppercase;
    margin-bottom: 1em;
}

.story-text {
    flex: 1 1;
    overflow-y: auto; 
    /* text-align: justify; */
    /* max-width: 60ch; */
    margin: 0 auto;
    column-count: 2;
    column-gap: 30px;
}

@media (max-width: 576px) {
    .story-text {
        column-count: 1 !important;
    }
}

.story-text h1, h2, h3, h4, h5, h6 {
    font-family: 'Crimson', serif;
}

.story-text p {
    font-family: 'Crimson', serif;
    line-height: 1.3;
    margin: 0;
    margin-bottom: 1em;
}

.story-options {
    margin-top: auto; 
}

#map-container {
    margin-top: 20px;
    text-align: center;
    max-height: 50%; 
    overflow: hidden;
}

#map-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.section-content {
    margin-top: 20px;
    overflow-y: auto;
    flex: 1 1;
}

.book-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 10px;
}

@media (max-width: 1440px) {
    .book-image {
        max-width: 120px;
    }
}

.text-size-button{
    text-align: center;
    justify-content: center;
}

.button-panel, .text-size-controls, .speech-controls {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 1px;
}

.button-panel button, .text-size-controls button {
    margin: 0 5px;
}

/* Responsive design */
@media (max-width: 768px) {
    .main-content {
        flex-direction: column;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        justify-content: flex-start;
        overflow: scroll;
    }

    .paper {
        position: relative;
        top: 0;
        transform: none;
        z-index: 1;
    }
}

.scene-link {
    color: #000;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
}

.scene-link:hover {
    color: #111827;
    border-bottom-color: #111827;
    font-family: 'Crimson', serif;
}

.btn-outline-sm {
    background-color: transparent;
    border: 1px solid #D1D5DB; /* gray-300 */
    padding: 0.5rem 1rem;
    font-size: 0.875rem; /* 14px */
    font-weight: 500;
    color: #374151; /* gray-700 */
    display: inline-flex;
    align-items: center;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}

.jump-to-section {
    display: flex;
    flex-direction: row;
    font-family: 'Crimson', serif;
    gap: 0.5rem;
    margin-top: 1rem;
    width: 100%; /* Ensure full width */
}

.sidebar .jump-to-section .btn.theme-button {
    min-width: auto;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0;
    gap: 0;
    width: 70px !important;
    box-sizing: border-box;
}

.sidebar .jump-to-section .btn.theme-button svg {
    width: 25px !important;
    height: 25px !important;
}

.sidebar .jump-to-section  .section-input {
    width: 100%;
    border: 1px solid rgba(135, 134, 127, 0.25);
    border-radius: 50px;
    background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));
    background-color: #fff;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 0;
    padding: 0 20px;
    height: 40px;
    background-clip: padding-box;
    font-family: "Gabarito", serif;
    font-size: 16px;
}

.sidebar .jump-to-section  .section-input:focus {
    box-shadow: none;
    outline: none;
}

.sidebar .jump-to-section  .section-input::placeholder {
    font-family: "Gabarito", serif;
    font-size: 16px;
    color: #9b9b9b;
}

/* Adjust sidebar content layout */
.sidebar-content {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%; /* Ensure full width */
}

.button-panel,
.text-size-controls,
.speech-controls {
    display: flex;
    gap: 0.5rem;
    width: 100%; /* Ensure full width */
    flex: 1 1;
}
/* 
.content-panel {
  padding: 1rem;
  background-color: #f5f5f5;
  border-left: 1px solid #ddd;
} */

.scene-map {
  margin-bottom: 1rem;
}

.scene-map img {
  max-width: 100%;
  height: auto;
  display: block;
}

.scene-description p {
    font-family: 'Crimson', serif;
    font-style: italic;
    color: #333;
}

.audio-player {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fcfcfc;
    border: 1px solid #E5E7EB;
    padding: 16px;
    border-radius: 10px;
    transition: all 0.2s ease;
}

  .audio-progress {
    width: 100%;
    max-width: 600px;
    flex-grow: 1;
    margin: 0 8px;
    position: relative;
  }
  
  .progress-slider {
    -webkit-appearance: none;
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: rgb(230 226 221);
    outline: none;
    position: relative;
    cursor: pointer;
  }
  
  .progress-slider::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: linear-gradient(to right, #df2d11 var(--progress, 0%), rgb(230 226 221) var(--progress, 0%));
  }
  
  .progress-slider::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #df2d11;
    cursor: pointer;
    margin-top: -4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  
  .progress-slider::-webkit-slider-thumb:hover {
    transform: scale(1.2);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
  
  .progress-slider::-moz-range-track {
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: linear-gradient(to right, #df2d11 var(--progress, 0%), rgb(230 226 221) var(--progress, 0%));
  }
  
  .progress-slider::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #df2d11;
    cursor: pointer;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  
  .progress-slider::-moz-range-thumb:hover {
    transform: scale(1.2);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
  
  .time-display {
    font-size: 0.75rem;
    color: #454545;
    min-width: 45px;
    text-align: center;
    font-family: monospace;
  }
  
  .volume-control {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 2px;
  }
  
  .volume-icon {
    font-size: 12px;
    margin-right: 3px;
  }
  
  .volume-slider {
    flex-grow: 1;
    -webkit-appearance: none;
    height: 4px;
    background: linear-gradient(to right, #df2d11, #E5E7EB);
    border-radius: 2px;
    outline: none;
    opacity: 0.7;
    transition: opacity 0.2s;
  }
  
  .volume-slider:hover {
    opacity: 1;
  }
  
  .volume-slider::-webkit-slider-thumb {
    width: 12px;
    height: 12px;
    background: #df2d11;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  
  .volume-slider::-webkit-slider-thumb:hover {
    transform: scale(1.1);
  }
  
  .volume-slider::-moz-range-thumb {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #007bff;
    cursor: pointer;
  }

.background-music-control {
  margin-top: 10px;
}

.background-music-control button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.background-music-control button svg {
  margin-right: 5px;
}

/* Enhance content panel styling */
/* .content-panel {
    flex: 1;
    padding: 1.5rem;
    background-color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    margin: 16px;
    height: calc(95vh - 157px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.2s ease;
} */

/* Improve audio player aesthetics */
.audio-player {
    background-color: #fcfcfc;
    border: 1px solid #E5E7EB;
    padding: 16px;
    border-radius: 10px;
    transition: all 0.2s ease;
}

/* Enhance volume slider */
.volume-slider {
    height: 4px;
    background: linear-gradient(to right, #df2d11, #E5E7EB);
    border-radius: 2px;
}

.volume-slider::-webkit-slider-thumb {
    width: 12px;
    height: 12px;
    background: #df2d11;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
}

.volume-slider::-webkit-slider-thumb:hover {
    transform: scale(1.1);
}

/* Improve section input */
.section-input {
    padding: 10px 16px;
    border: 1px solid #E5E7EB;
    background-color: #ffffff;
    transition: all 0.2s ease;
}

.section-input:focus {
    border-color: #df2d11;
    box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
}

/* Enhanced book image */
.book-image {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

/* Improve map container */
#map-container {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

#map-image {
    border-radius: 6px;
    transition: all 0.3s ease;
}

/* Enhanced Audio Player Styles */
.audio-progress {
    width: 100%;
    max-width: 600px; /* Increased from 540px */
    flex-grow: 1;
    margin: 0 8px;
    position: relative;
}

/* Improve time display */
.time-display {
    font-size: 0.75rem;
    color: #454545;
    min-width: 45px;
    text-align: center;
    font-family: monospace;
}

/* Enhance book title and chapter display */
.book-title {
    font-family: "Gabarito", serif;
    font-size: 1.5rem;
    color: #1a1a1a;
    margin: 12px 0 4px 0;
    text-align: center;
}

.current-chapter {
    font-size: 0.9rem;
    color: #454545;
    margin-bottom: 16px;
    text-align: center;
    font-style: italic;
}

/* Improve sidebar buttons layout */


.sidebar button:hover {
    background-color: #f8f9fa;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.sidebar button:active {
    transform: translateY(0);
}

/* Add subtle hover effect to story container */
.story-container {
    transition: all 0.3s ease;
}

/* Improve scrollbar aesthetics */
.text-panel::-webkit-scrollbar,
.story-text::-webkit-scrollbar {
    width: 6px;
}

.text-panel::-webkit-scrollbar-thumb,
.story-text::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    -webkit-transition: background-color 0.2s ease;
    transition: background-color 0.2s ease;
}

.text-panel::-webkit-scrollbar-thumb:hover,
.story-text::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 6px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}


/* Improve mobile experience */
@media (max-width: 768px) {
    .sidebar {
        padding: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
    
    .book-title {
        font-size: 1.25rem;
    }
}

/* Add focus states for accessibility */
button:focus-visible,
.section-input:focus-visible,
.progress-slider:focus-visible {
    outline: 2px solid #df2d11;
    outline-offset: 2px;
}

/* Enhance text selection */
::selection {
    background-color: rgba(0, 102, 204, 0.1);
    color: inherit;
}

/* Fix background music toggle button */
.bg-music-toggle {
    background: none;
    justify-content: center;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    transition: all 0.2s ease;
}

.bg-music-toggle:hover {
    opacity: 1;
    transform: scale(1.05);
    background-color: rgba(0, 102, 204, 0.1);
}

.bg-music-toggle svg {
    width: 20px;
    height: 20px;
    color: #374151;
}

/* Remove text from button, only show icon */
.bg-music-toggle span {
    display: none;
}

/* .btn.theme-button {
    background-color: red !important;
} */

.sidebar {
    height: calc(100vh - 64px);
}

.sidebar h1 {
    font-family: "Gabarito", serif;
    text-align: center;
    line-height: 1.1;
    font-size: 28px;
    margin: 0;
}

.sidebar p {
    font-size: 22px;
    font-family: 'Crimson', serif;
    font-style: italic;
    margin: 0;
    margin-bottom: 20px;
    padding-bottom: 20px;
    width: 100% !important;
    text-align: center;
    border-bottom: 1px solid rgba(135, 134, 127, 0.25);
}

.sidebar .btn.theme-button {
    width: 100% !important;
    display: flex;
    gap: 10px;
    font-family: "Gabarito", serif;
    border: 1px solid rgba(135, 134, 127, 0.25);
    border-radius: 50px;
    background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));
    background-clip: padding-box;
}

.landing-page .btn.theme-button {
    display: flex;
    gap: 10px;
    font-family: "Gabarito", serif;
    border: 1px solid rgba(135, 134, 127, 0.25);
    border-radius: 50px;
    background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));
    background-clip: padding-box;
}

.sidebar .btn.theme-button:hover,
.landing-page .btn.theme-button:hover {
    border: 1px solid rgba(135, 134, 127, 0.5);
}

.sidebar .btn.theme-button:focus,
.landing-page .btn.theme-button:focus {
    border: 1px solid rgba(135, 134, 127, 0.25);
}

.sidebar .btn.theme-button > .icon,
.landing-page .btn.theme-button > .icon {
    left: auto;
    position: relative;
}

.sidebar .btn.theme-button > .icon svg,
.landing-page .btn.theme-button > .icon svg {
    width: 20px;
    height: 20px; 
}

.sidebar .btn.theme-button span,
.landing-page .btn.theme-button span {
    color: #454545;
    font-size: 16px;
}

.landing-page .btn.theme-button.theme-button--cta {
    background: #df2d11;
    border: 1px solid #bc230b;
}

.landing-page .btn.theme-button.theme-button--cta span {
    color: #fff;
}

.landing-page .btn.theme-button.theme-button--cta:hover {
    background: #bc230b;
}

.audio-controls {
    margin-top: 15px;
    margin-bottom: 0;
}

.audio-controls .btn {
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    margin-right: 10px !important; 
}

.audio-controls .btn .drip {
    display: none;
}

.audio-controls .btn svg {
    width: 25px !important;
    height: 25px !important;
}

.progress-slider {
    top: -3px;
}

.theme-button--w100 {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB;+DACgE;IAChE,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB;+DACwE;IACxE,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB;+DAC8E;IAC9E,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC0E;IAC1E,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB;+DAC2E;IAC3E,gBAAgB;AACpB;;AAEA;;;GAGG;;AAMH;EACE,8BAA8B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAO;IACP,0BAA0B;IAC1B,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,wCAAwC;IAC5C;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;;IAGA;QACI,aAAa;QACb,SAAS;QACT,8BAA8B;QAC9B,2CAA2C;QAC3C,mBAAmB;QACnB,qEAAqE;QACrE,4BAA4B;QAC5B,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,oFAAiF;IACjF,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;IACI,eAAe;IACf,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IAEI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,SAAS;IACT,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,6BAA6B;QAC7B,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,eAAe;QACf,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB,EAAE,aAAa;IACxC,oBAAoB;IACpB,mBAAmB,EAAE,SAAS;IAC9B,gBAAgB;IAChB,cAAc,EAAE,aAAa;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,4EAA4E;AAChF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,WAAW,EAAE,sBAAsB;AACvC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,4BAA4B;IAC5B,UAAU;IACV,MAAM;IACN,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,mBAAmB;IACnB,qEAAqE;IACrE,sBAAsB;IACtB,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW,EAAE,sBAAsB;AACvC;;AAEA;;;IAGI,aAAa;IACb,WAAW;IACX,WAAW,EAAE,sBAAsB;IACnC,SAAO;AACX;AACA;;;;;GAKG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;EAEE;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,wGAAwG;EAC1G;;EAEA;IAEE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,iCAAyB;IAAzB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,wGAAwG;EAC1G;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,8BAAyB;IAAzB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,uDAAuD;IACvD,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,iCAAyB;IAAzB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;;;;;;;;;;;;;GAaG;;AAEH,oCAAoC;AACpC;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,WAAW;IACX,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,iCAAyB;IAAzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,wBAAwB;AACxB;IACI,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,gBAAgB,EAAE,yBAAyB;IAC3C,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,2CAA2C;AAC3C;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,mCAAmC;;;AAGnC;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,+CAA+C;AAC/C;IACI,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;;IAEI,UAAU;AACd;;AAEA;;IAEI,oCAAoC;IACpC,kBAAkB;IAClB,8CAAsC;IAAtC,sCAAsC;AAC1C;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,gDAAgD;AACpD;;;AAGA,8BAA8B;AAC9B;IACI;QACI,aAAa;QACb,4CAA4C;IAChD;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,uCAAuC;AACvC;;;IAGI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,aAAa;AACjB;;AAEA;;GAEG;;AAEH;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,qEAAqE;IACrE,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,qEAAqE;IACrE,4BAA4B;AAChC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;;IAEI,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["@font-face {\n    font-family: 'Gabarito';\n    src: url('../public/fonts/Gabarito-Regular.woff2') format('woff2'),\n         url('../public/fonts/Gabarito-Regular.woff') format('woff');\n    font-weight: 400;\n}\n\n@font-face {\n    font-family: 'Crimson';\n    src: url('../public/fonts/crimson/CrimsonText-Bold.woff2') format('woff2'),\n         url('../public/fonts/crimson/CrimsonText-Bold.woff') format('woff');\n    font-weight: 700;\n}\n\n@font-face {\n    font-family: 'Crimson';\n    src: url('../public/fonts/crimson/CrimsonText-BoldItalic.woff2') format('woff2'),\n         url('../public/fonts/crimson/CrimsonText-BoldItalic.woff') format('woff');\n    font-weight: 700;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Crimson';\n    src: url('../public/fonts/crimson/CrimsonText-Italic.woff2') format('woff2'),\n         url('../public/fonts/crimson/CrimsonText-Italic.woff') format('woff');\n    font-weight: normal;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Crimson';\n    src: url('../public/fonts/crimson/CrimsonText-Regular.woff2') format('woff2'),\n         url('../public/fonts/crimson/CrimsonText-Regular.woff') format('woff');\n    font-weight: 400;\n}\n\n/* body {\n    font-family: \"Gabarito\", serif;\n    font-family: 'Crimson', serif;\n} */\n\n::-moz-selection { /* Code for Firefox */\n  background: #df2d11 !important;\n}\n\n::selection {\n  background: #df2d11 !important;\n}\n\n.App {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    background-color: #faf8f5;\n}\n\n.story-page {\n    display: flex;\n    height: calc(100vh - 65px);\n    overflow: hidden;\n}\n\n.sidebar {\n    width: 300px;\n    height: 100%;\n    overflow-y: auto;    \n    padding: 40px 24px;\n    box-sizing: border-box;\n}\n\n.sidebar-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.main-content {\n    overflow: hidden;\n    width: 100%;\n    padding: 40px 64px;\n    gap: 20px;\n    flex: 1;\n    height: calc(100vh - 65px);\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    background: #ded8d1;\n    margin-right: 40px;\n    border-radius: 12px;\n    height: calc(100% - 30px);\n}\n\n.book-image {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n    margin-bottom: 10px;\n}\n\n@media (max-height: 800px)  {\n    .main-content {\n        height: auto;\n    }\n}\n\n/* Responsive design */\n@media (max-width: 1200px) {\n    .sidebar {\n        display: none;\n    }\n\n    .sidebar.show {\n        display: block;\n        position: fixed;\n        z-index: 998;\n        background: #fcfaf7;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n\n    .main-content {\n        padding: 40px 24px;\n        margin: 0 16px;\n        width: auto;\n    }\n\n    .paper-wrapper {\n        width: auto;\n    }\n\n    .story-page {\n        flex-direction: column;\n    }\n\n\n    .toggle-sidebar.btn.theme-button {\n        display: flex;\n        gap: 10px;\n        font-family: \"Gabarito\", serif;\n        border: 1px solid rgba(135, 134, 127, 0.25);\n        border-radius: 50px;\n        background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));\n        background-clip: padding-box;\n        margin: 20px 16px;\n        box-sizing: border-box;\n    }\n\n    .toggle-sidebar.btn.theme-button:hover {\n        border: 1px solid rgba(135, 134, 127, 0.5);\n    }\n\n    .toggle-sidebar.btn.theme-button:focus {\n        border: 1px solid rgba(135, 134, 127, 0.25);\n    }\n\n    .toggle-sidebar.btn.theme-button > .icon {\n        left: auto;\n        position: relative;\n    }\n\n    .toggle-sidebar.btn.theme-button > .icon svg {\n        width: 20px;\n        height: 20px; \n    }\n\n    .toggle-sidebar.btn.theme-button span {\n        color: #454545;\n        font-size: 16px;\n    }\n\n    .hide-sidebar {\n        position: relative;\n        top: -10px;\n        width: 32px;\n        height: 32px;\n        margin-left: auto;     \n        display: flex;\n        justify-content: center;   \n        align-items: center;\n        cursor: pointer;\n        border-radius: 4px;\n    }\n\n    .hide-sidebar:hover {\n        background: rgba(0, 0, 0, 0.05);\n    }\n\n    .hide-sidebar svg {\n        width: 30px;\n        height: 30px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .toggle-sidebar,\n    .hide-sidebar {\n        display: none !important;\n    }\n}\n\n.text-panel {\n    box-sizing: border-box;\n}\n\n.paper-wrapper {\n    position: relative;\n    width: 100%;\n    max-width: calc((100vh - 1rem - 2rem) * 0.69);\n    max-height: calc(100vh - 1rem - 2rem);\n}\n\n.paper {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 0;\n    padding-bottom: 130%;\n    border-radius: 2px;\n    transform: translateY(-50%);\n    background: url(\"../public/assets/parchment.png\") no-repeat center/cover, #ffffff;\n    filter: grayscale(40%);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* .paper::before {\n    content: '';\n    background: url(\"../public/assets/parchment.png\") no-repeat center/cover, #ffffff;\n    filter: grayscale(40%);\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    z-index: -1;\n    background-repeat: no-repeat;\n    background-size: cover;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n} */\n\n.paper-wrapper .paper .paper-content {\n    padding: 6.593%;\n    padding-left: 8.571%;\n    padding-right: 5.714%;\n}\n\n.paper-wrapper:not(.text-panel) .paper .paper-content {\n    padding-right: 8.571%;\n    padding-left: 5.714%;\n}\n\n.paper-wrapper:not(.text-panel) .paper::before {\n    -webkit-transform: scaleX(-1) rotate(180deg);\n    transform: scaleX(-1) rotate(180deg);\n}\n\n.paper-wrapper .paper-container {    \n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    overflow-y: scroll;\n}\n\n.story-container {\n    margin: 0 auto;\n    font-size: 17px;\n    line-height: 1.3;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    flex: 1 1;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n}\n\n.story-container > div h2 {\n    font-size: clamp(16px, 2vw, 28px);\n    margin: 0;\n    text-transform: uppercase;\n    margin-bottom: 1em;\n}\n\n.story-text {\n    flex: 1;\n    overflow-y: auto; \n    /* text-align: justify; */\n    /* max-width: 60ch; */\n    margin: 0 auto;\n    column-count: 2;\n    column-gap: 30px;\n}\n\n@media (max-width: 576px) {\n    .story-text {\n        column-count: 1 !important;\n    }\n}\n\n.story-text h1, h2, h3, h4, h5, h6 {\n    font-family: 'Crimson', serif;\n}\n\n.story-text p {\n    font-family: 'Crimson', serif;\n    line-height: 1.3;\n    margin: 0;\n    margin-bottom: 1em;\n}\n\n.story-options {\n    margin-top: auto; \n}\n\n#map-container {\n    margin-top: 20px;\n    text-align: center;\n    max-height: 50%; \n    overflow: hidden;\n}\n\n#map-image {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n}\n\n.section-content {\n    margin-top: 20px;\n    overflow-y: auto;\n    flex: 1;\n}\n\n.book-image {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n    margin-bottom: 10px;\n}\n\n@media (max-width: 1440px) {\n    .book-image {\n        max-width: 120px;\n    }\n}\n\n.text-size-button{\n    text-align: center;\n    justify-content: center;\n}\n\n.button-panel, .text-size-controls, .speech-controls {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin-top: 1px;\n}\n\n.button-panel button, .text-size-controls button {\n    margin: 0 5px;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n    .main-content {\n        flex-direction: column;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        justify-content: flex-start;\n        overflow: scroll;\n    }\n\n    .paper {\n        position: relative;\n        top: 0;\n        transform: none;\n        z-index: 1;\n    }\n}\n\n.scene-link {\n    color: #000;\n    text-decoration: underline;\n    cursor: pointer;\n    font-weight: 700;\n}\n\n.scene-link:hover {\n    color: #111827;\n    border-bottom-color: #111827;\n    font-family: 'Crimson', serif;\n}\n\n.btn-outline-sm {\n    background-color: transparent;\n    border: 1px solid #D1D5DB; /* gray-300 */\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem; /* 14px */\n    font-weight: 500;\n    color: #374151; /* gray-700 */\n    display: inline-flex;\n    align-items: center;\n    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;\n}\n\n.jump-to-section {\n    display: flex;\n    flex-direction: row;\n    font-family: 'Crimson', serif;\n    gap: 0.5rem;\n    margin-top: 1rem;\n    width: 100%; /* Ensure full width */\n}\n\n.sidebar .jump-to-section .btn.theme-button {\n    min-width: auto;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    padding: 0;\n    gap: 0;\n    width: 70px !important;\n    box-sizing: border-box;\n}\n\n.sidebar .jump-to-section .btn.theme-button svg {\n    width: 25px !important;\n    height: 25px !important;\n}\n\n.sidebar .jump-to-section  .section-input {\n    width: 100%;\n    border: 1px solid rgba(135, 134, 127, 0.25);\n    border-radius: 50px;\n    background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));\n    background-color: #fff;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    border-right: 0;\n    padding: 0 20px;\n    height: 40px;\n    background-clip: padding-box;\n    font-family: \"Gabarito\", serif;\n    font-size: 16px;\n}\n\n.sidebar .jump-to-section  .section-input:focus {\n    box-shadow: none;\n    outline: none;\n}\n\n.sidebar .jump-to-section  .section-input::placeholder {\n    font-family: \"Gabarito\", serif;\n    font-size: 16px;\n    color: #9b9b9b;\n}\n\n/* Adjust sidebar content layout */\n.sidebar-content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    width: 100%; /* Ensure full width */\n}\n\n.button-panel,\n.text-size-controls,\n.speech-controls {\n    display: flex;\n    gap: 0.5rem;\n    width: 100%; /* Ensure full width */\n    flex: 1;\n}\n/* \n.content-panel {\n  padding: 1rem;\n  background-color: #f5f5f5;\n  border-left: 1px solid #ddd;\n} */\n\n.scene-map {\n  margin-bottom: 1rem;\n}\n\n.scene-map img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.scene-description p {\n    font-family: 'Crimson', serif;\n    font-style: italic;\n    color: #333;\n}\n\n.audio-player {\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: #fcfcfc;\n    border: 1px solid #E5E7EB;\n    padding: 16px;\n    border-radius: 10px;\n    transition: all 0.2s ease;\n}\n\n  .audio-progress {\n    width: 100%;\n    max-width: 600px;\n    flex-grow: 1;\n    margin: 0 8px;\n    position: relative;\n  }\n  \n  .progress-slider {\n    -webkit-appearance: none;\n    width: 100%;\n    height: 4px;\n    border-radius: 2px;\n    background: rgb(230 226 221);\n    outline: none;\n    position: relative;\n    cursor: pointer;\n  }\n  \n  .progress-slider::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 4px;\n    border-radius: 2px;\n    background: linear-gradient(to right, #df2d11 var(--progress, 0%), rgb(230 226 221) var(--progress, 0%));\n  }\n  \n  .progress-slider::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background: #df2d11;\n    cursor: pointer;\n    margin-top: -4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s ease;\n  }\n  \n  .progress-slider::-webkit-slider-thumb:hover {\n    transform: scale(1.2);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  }\n  \n  .progress-slider::-moz-range-track {\n    width: 100%;\n    height: 4px;\n    border-radius: 2px;\n    background: linear-gradient(to right, #df2d11 var(--progress, 0%), rgb(230 226 221) var(--progress, 0%));\n  }\n  \n  .progress-slider::-moz-range-thumb {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background: #df2d11;\n    cursor: pointer;\n    border: none;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s ease;\n  }\n  \n  .progress-slider::-moz-range-thumb:hover {\n    transform: scale(1.2);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  }\n  \n  .time-display {\n    font-size: 0.75rem;\n    color: #454545;\n    min-width: 45px;\n    text-align: center;\n    font-family: monospace;\n  }\n  \n  .volume-control {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin-top: 2px;\n  }\n  \n  .volume-icon {\n    font-size: 12px;\n    margin-right: 3px;\n  }\n  \n  .volume-slider {\n    flex-grow: 1;\n    -webkit-appearance: none;\n    height: 4px;\n    background: linear-gradient(to right, #df2d11, #E5E7EB);\n    border-radius: 2px;\n    outline: none;\n    opacity: 0.7;\n    transition: opacity 0.2s;\n  }\n  \n  .volume-slider:hover {\n    opacity: 1;\n  }\n  \n  .volume-slider::-webkit-slider-thumb {\n    width: 12px;\n    height: 12px;\n    background: #df2d11;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s ease;\n  }\n  \n  .volume-slider::-webkit-slider-thumb:hover {\n    transform: scale(1.1);\n  }\n  \n  .volume-slider::-moz-range-thumb {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #007bff;\n    cursor: pointer;\n  }\n\n.background-music-control {\n  margin-top: 10px;\n}\n\n.background-music-control button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.background-music-control button svg {\n  margin-right: 5px;\n}\n\n/* Enhance content panel styling */\n/* .content-panel {\n    flex: 1;\n    padding: 1.5rem;\n    background-color: #ffffff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    border-radius: 12px;\n    margin: 16px;\n    height: calc(95vh - 157px);\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    border-left: 1px solid rgba(0, 0, 0, 0.08);\n    transition: all 0.2s ease;\n} */\n\n/* Improve audio player aesthetics */\n.audio-player {\n    background-color: #fcfcfc;\n    border: 1px solid #E5E7EB;\n    padding: 16px;\n    border-radius: 10px;\n    transition: all 0.2s ease;\n}\n\n/* Enhance volume slider */\n.volume-slider {\n    height: 4px;\n    background: linear-gradient(to right, #df2d11, #E5E7EB);\n    border-radius: 2px;\n}\n\n.volume-slider::-webkit-slider-thumb {\n    width: 12px;\n    height: 12px;\n    background: #df2d11;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s ease;\n}\n\n.volume-slider::-webkit-slider-thumb:hover {\n    transform: scale(1.1);\n}\n\n/* Improve section input */\n.section-input {\n    padding: 10px 16px;\n    border: 1px solid #E5E7EB;\n    background-color: #ffffff;\n    transition: all 0.2s ease;\n}\n\n.section-input:focus {\n    border-color: #df2d11;\n    box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);\n}\n\n/* Enhanced book image */\n.book-image {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    transition: all 0.3s ease;\n}\n\n/* Improve map container */\n#map-container {\n    background-color: #ffffff;\n    border-radius: 10px;\n    padding: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n#map-image {\n    border-radius: 6px;\n    transition: all 0.3s ease;\n}\n\n/* Enhanced Audio Player Styles */\n.audio-progress {\n    width: 100%;\n    max-width: 600px; /* Increased from 540px */\n    flex-grow: 1;\n    margin: 0 8px;\n    position: relative;\n}\n\n/* Improve time display */\n.time-display {\n    font-size: 0.75rem;\n    color: #454545;\n    min-width: 45px;\n    text-align: center;\n    font-family: monospace;\n}\n\n/* Enhance book title and chapter display */\n.book-title {\n    font-family: \"Gabarito\", serif;\n    font-size: 1.5rem;\n    color: #1a1a1a;\n    margin: 12px 0 4px 0;\n    text-align: center;\n}\n\n.current-chapter {\n    font-size: 0.9rem;\n    color: #454545;\n    margin-bottom: 16px;\n    text-align: center;\n    font-style: italic;\n}\n\n/* Improve sidebar buttons layout */\n\n\n.sidebar button:hover {\n    background-color: #f8f9fa;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.sidebar button:active {\n    transform: translateY(0);\n}\n\n/* Add subtle hover effect to story container */\n.story-container {\n    transition: all 0.3s ease;\n}\n\n/* Improve scrollbar aesthetics */\n.text-panel::-webkit-scrollbar,\n.story-text::-webkit-scrollbar {\n    width: 6px;\n}\n\n.text-panel::-webkit-scrollbar-thumb,\n.story-text::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.1);\n    border-radius: 3px;\n    transition: background-color 0.2s ease;\n}\n\n.text-panel::-webkit-scrollbar-thumb:hover,\n.story-text::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(0, 0, 0, 0.2);\n}\n\n::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, 0.3);\n    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);\n}\n\n\n/* Improve mobile experience */\n@media (max-width: 768px) {\n    .sidebar {\n        padding: 16px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n    }\n    \n    .book-title {\n        font-size: 1.25rem;\n    }\n}\n\n/* Add focus states for accessibility */\nbutton:focus-visible,\n.section-input:focus-visible,\n.progress-slider:focus-visible {\n    outline: 2px solid #df2d11;\n    outline-offset: 2px;\n}\n\n/* Enhance text selection */\n::selection {\n    background-color: rgba(0, 102, 204, 0.1);\n    color: inherit;\n}\n\n/* Fix background music toggle button */\n.bg-music-toggle {\n    background: none;\n    justify-content: center;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0.8;\n    transition: all 0.2s ease;\n}\n\n.bg-music-toggle:hover {\n    opacity: 1;\n    transform: scale(1.05);\n    background-color: rgba(0, 102, 204, 0.1);\n}\n\n.bg-music-toggle svg {\n    width: 20px;\n    height: 20px;\n    color: #374151;\n}\n\n/* Remove text from button, only show icon */\n.bg-music-toggle span {\n    display: none;\n}\n\n/* .btn.theme-button {\n    background-color: red !important;\n} */\n\n.sidebar {\n    height: calc(100vh - 64px);\n}\n\n.sidebar h1 {\n    font-family: \"Gabarito\", serif;\n    text-align: center;\n    line-height: 1.1;\n    font-size: 28px;\n    margin: 0;\n}\n\n.sidebar p {\n    font-size: 22px;\n    font-family: 'Crimson', serif;\n    font-style: italic;\n    margin: 0;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    width: 100% !important;\n    text-align: center;\n    border-bottom: 1px solid rgba(135, 134, 127, 0.25);\n}\n\n.sidebar .btn.theme-button {\n    width: 100% !important;\n    display: flex;\n    gap: 10px;\n    font-family: \"Gabarito\", serif;\n    border: 1px solid rgba(135, 134, 127, 0.25);\n    border-radius: 50px;\n    background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));\n    background-clip: padding-box;\n}\n\n.landing-page .btn.theme-button {\n    display: flex;\n    gap: 10px;\n    font-family: \"Gabarito\", serif;\n    border: 1px solid rgba(135, 134, 127, 0.25);\n    border-radius: 50px;\n    background-image: linear-gradient(rgb(248 246 244), rgb(230 226 221));\n    background-clip: padding-box;\n}\n\n.sidebar .btn.theme-button:hover,\n.landing-page .btn.theme-button:hover {\n    border: 1px solid rgba(135, 134, 127, 0.5);\n}\n\n.sidebar .btn.theme-button:focus,\n.landing-page .btn.theme-button:focus {\n    border: 1px solid rgba(135, 134, 127, 0.25);\n}\n\n.sidebar .btn.theme-button > .icon,\n.landing-page .btn.theme-button > .icon {\n    left: auto;\n    position: relative;\n}\n\n.sidebar .btn.theme-button > .icon svg,\n.landing-page .btn.theme-button > .icon svg {\n    width: 20px;\n    height: 20px; \n}\n\n.sidebar .btn.theme-button span,\n.landing-page .btn.theme-button span {\n    color: #454545;\n    font-size: 16px;\n}\n\n.landing-page .btn.theme-button.theme-button--cta {\n    background: #df2d11;\n    border: 1px solid #bc230b;\n}\n\n.landing-page .btn.theme-button.theme-button--cta span {\n    color: #fff;\n}\n\n.landing-page .btn.theme-button.theme-button--cta:hover {\n    background: #bc230b;\n}\n\n.audio-controls {\n    margin-top: 15px;\n    margin-bottom: 0;\n}\n\n.audio-controls .btn {\n    padding: 0 !important;\n    border: none !important;\n    background: transparent !important;\n    margin-right: 10px !important; \n}\n\n.audio-controls .btn .drip {\n    display: none;\n}\n\n.audio-controls .btn svg {\n    width: 25px !important;\n    height: 25px !important;\n}\n\n.progress-slider {\n    top: -3px;\n}\n\n.theme-button--w100 {\n  width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
